import {publicProfile} from './Public/publicProfile';
import {privateProfile} from './Private/privateProfile';

export const profiles = [publicProfile, privateProfile];
